<template>
  <common-modal :is-show-close="isShowClose">
    <div class="reject-wrap">
      <h1 class="title">请选择驳回理由</h1>
      <ul>
        <li :class="flag == 1 ? 'active' : ''" @click="flag = 1">未解决问题</li>
        <li :class="flag == 2 ? 'active' : ''" @click="flag = 2">其它原因</li>
      </ul>
      <textarea v-model="content" v-if="flag == 2"></textarea>
      <div class="btn-wrap">
        <div class="cancel" @click="close">取消</div>
        <div class="submit" @click="submit">确定</div>
      </div>
    </div>
  </common-modal>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
import {operateOrder} from '@/api/order.js';
export default {
  components: {
    commonModal
  },
  data() {
    return {
      reason: '未解决问题',
      isShowClose: false,
      flag: 1,
      content: '',
      order_uuid: this.$route.query.order_uuid			// 主要用于获取订单详情页uuid
    };
  },

  methods: {
    close() {
      this.$emit('close');
    },

    reset() {
      this.reason = '未解决问题';
      this.flag = 1;
      this.content = '';
    },

    getCommentInfo(order_uuid) {
      this.order_uuid = order_uuid
    },

    async submit() {
      if (this.flag == '2') {
        if (!this.content) {
          this.$message('请输入驳回理由');
          return;
        }
        if (!this.content.length > 100) {
          this.$message('驳回理由不得超过100字');
          return;
        }
        this.reason = this.content;
      }
      const parmas = {type: 3, reason_for_rejection: this.reason};
      const {data, status} = await operateOrder(this.order_uuid, parmas);
      if (status !== 200) return;
      this.reset();
      this.close();
      this.$message.success('驳回成功');
      this.$parent.getOrderList();
    }
  }
};
</script>

<style lang="scss" scoped>
	textarea::-webkit-input-placeholder {
		@include textarea-placeholder;
	}

	textarea::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		@include textarea-placeholder;
	}

	textarea:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		@include textarea-placeholder;
	}

	textarea:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		@include textarea-placeholder;
	}

	.reject-wrap {
		padding: 30px;

		h1 {
			text-align: center;
			@include font-style;
			font-size: 20px;
			color: #000000;
		}

		ul {
			margin: 30px 0;

			li {
				@include font-style;
				@include cursor-style;
				font-size: 18px;
				color: #000;
				padding-left: 28px;
				background: url(../assets/img/drawback.png) no-repeat left center;
				background-size: 20px;
				margin-bottom: 16px;
			}

			.active {
				background: url(../assets/img/complete.png) no-repeat left center;
				background-size: 20px;
			}
		}

		textarea {
			width: 100%;
			box-sizing: border-box;
			resize: none;
			padding: 20px 0 0 20px;
			height: 150px;
			background: #f5f9fc;
		}

		//弹框按钮
		.btn-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			margin-top: 30px;

			.submit {
				@include cursor-style;
				width: 80px;
				height: 36px;
				line-height: 36px;
				box-sizing: border-box;
				text-align: center;
				background: #ff8e1c;
				box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
				border-radius: 5px;
				font-size: 15px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #ffffff;
			}

			.cancel {
				@include cursor-style;
				@extend .submit;
				font-weight: 400;
				background: #ffffff;
				border: 1px solid #9a9a9a;
				color: #9a9a9a;
				margin-right: 20px;
			}
		}
	}
</style>
